// extracted by mini-css-extract-plugin
export default {"JobSubCategory":"job-sub-category_JobSubCategory__l5HPG"};